if (!Element.prototype.matches) {
    Element.prototype.matches =
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (Element.prototype as any).msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

// importing for the side effects, but TS requires files to be modules
export {};
